// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__30Se_","column":"style_column__33Yig"};